var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('div', {
    staticClass: "p-4"
  }, [_c('router-link', {
    staticClass: "button my-4",
    attrs: {
      "to": {
        name: 'LiffHuggiesCouponOfflineRedeem'
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("已兌換")]), _c('span', {
    staticClass: "h5 mb-0 font-weight-bold text-black"
  }, [_vm._v("實體門市折價券")])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }